document.addEventListener('DOMContentLoaded', function() {
  // Initialize tooltips
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });
  
  // Track selections
  const clipSelections = {
    1: null,
    2: null,
    3: null
  };
  
  function updatePreview(clipNumber, imageUrl) {
    const previewDiv = document.querySelector(`#preview-${clipNumber}`);
    if (previewDiv) {
      if (imageUrl) {
        previewDiv.innerHTML = `<img src="${imageUrl}>"`
        previewDiv.style.backgroundSize = 'cover';
        previewDiv.style.backgroundPosition = 'center';
      } else {
        previewDiv.style.backgroundImage = 'none';
      }
    }
    clipSelections[clipNumber] = imageUrl;
    
    updateSubmitButton();
  }
  
  function updateSubmitButton() {
    const submitButton = document.querySelector('button[type="submit"]');
    if (submitButton) {
      const isComplete = Object.values(clipSelections).every(v => v !== null);
      submitButton.disabled = !isComplete;
    }
  }
  
  // Update preview when radio buttons change
  document.querySelectorAll('.color-radio').forEach(function(radio) {
    radio.addEventListener('change', function() {
      const clipNumber = 1;
      const label = document.querySelector(`label[for="${this.id}"]`);
      
      if (label) {
        const fullImage = label.dataset.fullImage;
        updatePreview(clipNumber, fullImage);
        
        // Update selected state
        document.querySelectorAll(`[name="${this.name}"] + .color-swatch`).forEach(swatch => {
          swatch.style.borderColor = '#dee2e6';
          swatch.style.borderWidth = '2px';
        });
        label.style.borderColor = '#212529';
        label.style.borderWidth = '3px';
      }
    });
  });
  
  // Trigger change event on checked radios to initialize previews
  document.querySelectorAll('.color-radio:checked').forEach(function(radio) {
    radio.dispatchEvent(new Event('change'));
  });
});